import React from 'react';
import { DialogOverlay, DialogContent } from '@reach/dialog';
import { useDispatch, useSelector } from 'react-redux';
import { handleModelDelete } from './../../../actions/model';
import local from './../../../services/locals.json';

const DeleteModelDialog = ({ showDialog, closeDialog, model }) => {
    const dispatch = useDispatch();

    const lang = useSelector((state) => state.language);

    return (
        <DialogOverlay
            isOpen={showDialog}
            onDismiss={closeDialog}
            style={{ background: 'hsla(0, 100%, 100%, 0.9)' }}
        >
            <DialogContent
                aria-label="Warning about next steps"
                style={{
                    boxShadow: '0px 5px 10px hsla(0, 0%, 0%, 0.50)',
                }}
            >
                <div>
                    <h4 className=" text-center">
                        {local[lang].deleteModel} "{model.name}"
                    </h4>
                    <hr />
                    <p>
                        {' '}
                        {local[lang].deleteModelBody1} "{model.name}"{' '}
                        {local[lang].deleteModelBody2}
                    </p>
                </div>
                <button
                    className="btn btn-red "
                    style={{ borderRadius: '30px' }}
                    onClick={() =>
                        dispatch(
                            handleModelDelete(
                                model.urn,
                                `${model.name}.${model.type}`
                            )
                        ) && closeDialog()
                    }
                >
                    {local[lang].deleteConfirm}
                </button>
                <button
                    className={`btn btn-yellow ${
                        lang === 'fa' ? 'mr-2' : 'ml-2'
                    }`}
                    style={{ borderRadius: '30px' }}
                    onClick={closeDialog}
                >
                    {local[lang].cancel}
                </button>
            </DialogContent>
        </DialogOverlay>
    );
};

export default DeleteModelDialog;
